// extracted by mini-css-extract-plugin
module.exports = {"root":"ku","countbox":"kv","expireDate":"kw"};